exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dropdown-loader.ant-skeleton {\n  margin-top: 0;\n  padding: 1rem 0rem !important; }\n  .dropdown-loader.ant-skeleton .ant-skeleton-paragraph {\n    margin-top: 0 !important; }\n    .dropdown-loader.ant-skeleton .ant-skeleton-paragraph li {\n      height: 1rem !important;\n      padding: 0; }\n", ""]);

// exports
